import type {MarketResult,ResidentOrder,MarketReceipt,MarketOperation} from '@/shared/contracts';

/** Additive A031 contracts. MarketReceipt、MarketOperation 自 I106 起是生成契约（PHOTO-ASK-FLOW-01 契约同步），这里转出生成的同名类型、不再本地另写，免得同名遮蔽。 */
export type {MarketReceipt,MarketOperation};
export type OrderStatus='available'|'fulfilled'|'cancelled'|'expired';
export type SettlementStatus='not_settled'|'verified'|'legacy_unverified';
export type LifecycleOrder=ResidentOrder & {
 status?:OrderStatus;issued_at?:string|null;origin?:string|null;rule_version?:string|null;issued_unit_price?:number|null;
 generation_ref?:string|null;cancelled_at?:string|null;settled_pet_id?:string|null;settled_at?:string|null;
 receipt?:MarketReceipt|null;settlement_status?:SettlementStatus;
};
export type LifecycleResult=MarketResult & {receipt?:MarketReceipt|null;settled_pet_id?:string|null;settlement_status?:'verified'|'legacy_unverified'};
export function orderStatus(o:LifecycleOrder):OrderStatus|'legacy_unverified' {
 if(o.fulfilled)return 'fulfilled';
 return o.status==='available'||o.status==='fulfilled'||o.status==='cancelled'||o.status==='expired'?o.status:'legacy_unverified';
}
export const ORDER_STATUS_TEXT={available:'等待交货',fulfilled:'已交货',cancelled:'已取消',expired:'已过期',legacy_unverified:'旧单状态未确认'};
export function originText(origin:string|null|undefined) {
 return origin==='home_activation'?'入住时的委托':origin==='daily_issue'?'每日委托':origin==='fulfill_recovery'?'交货时补齐的委托':origin?'来源未识别':'来历未确认';
}
/** Fixed timezone independent of browser locale (UTC+8, same as the order day: web_market ORDER_TZ); null/invalid facts are never invented.
 * MARKET-SHEET-MSG-01: label 北京时间 — the product no longer defaults to Hong Kong; the order board note says 每天 0 点（北京时间）. */
export function marketTime(value:string|null|undefined):string {
 if(!value||!Number.isFinite(Date.parse(value)))return '时间未确认';
 const d=new Date(Date.parse(value)+8*3600000),n=(v:number)=>String(v).padStart(2,'0');
 return `${d.getUTCFullYear()}/${n(d.getUTCMonth()+1)}/${n(d.getUTCDate())} ${n(d.getUTCHours())}:${n(d.getUTCMinutes())}（北京时间）`;
}
export function orderCanAct(o:LifecycleOrder) {return !o.fulfilled&&(orderStatus(o)==='available'||orderStatus(o)==='legacy_unverified');}
export function receiptForOrder(o:LifecycleOrder,homeId:string|null):MarketReceipt|null {
 const r=o.receipt;
 return o.settlement_status==='verified'&&r?.kind==='order'&&r.home_id===homeId&&r.order_id===o.order_id&&r.item_key===o.item_key&&r.qty===o.qty&&r.coins===o.reward&&r.unit_price===o.issued_unit_price&&r.settled_pet_id===o.settled_pet_id&&r.created_at===o.settled_at?r:null;
}
